import { useI18n } from "@/app/composables/useI18n"

const { t } = useI18n()

const uppercaseRegex = /[A-Z]/
const lowercaseRegex = /[a-z]/
const numberRegex = /\d/
const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/

export function minimum8Characters(password) {
  if (
    password
    && password.length >= 8
    && password.length <= 28
    && uppercaseRegex.test(password)
    && lowercaseRegex.test(password)
    && numberRegex.test(password)
    && specialCharRegex.test(password)
  ) {
    return true
  }

  return t("account.password_rule_general")
}

export function minimum6Characters(password) {
  if (password && password.length >= 6) {
    return true
  }

  return t("account.password_rule_general")
}

export const rules = [minimum6Characters]
